import { render, staticRenderFns } from "./Phases.vue?vue&type=template&id=fe0b5bb6&scoped=true&"
import script from "./Phases.vue?vue&type=script&lang=js&"
export * from "./Phases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0b5bb6",
  null
  
)

export default component.exports